import * as Yup from 'yup';

export const assignAlertsValidationSchema = Yup.object().shape({
  assigneeId: Yup.string().required('Please select a assignee'),
});
